import {documentToHtmlString, Options} from "@contentful/rich-text-html-renderer"
import {BLOCKS} from "@contentful/rich-text-types"
import clsx from "clsx"
import "./Reader.css"

const YOUTUBE_VIDEO_1 = "https://www.youtube.com/watch?v="
const YOUTUBE_VIDEO_2 = "https://youtu.be/"
const VIMEO_VIDEO = "https://vimeo.com/"
const CONTENTFUL_VIDEO = "https://videos.ctfassets.net/"
const CONTENTFUL_IMAGE = "https://images.ctfassets.net/"

type RichContent = Queries.MagazinePostQuery["allContentfulContenutoMagazine"]["edges"][0]["node"]["content"]

type ReferenceData = {
    readonly target: {readonly sys: {readonly id: string; readonly type: string; readonly linkType: string}}
}
type Reference = {
    readonly contentful_id: string
    readonly title: string | null
    readonly url: string | null
    readonly height: string | null
    readonly sys: {readonly type: string | null} | null
}

export interface ReaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "children"> {
    children: RichContent
    asSubBlock?: boolean
}

const Reader: React.FC<ReaderProps> = props => {
    const {children, className, asSubBlock = false, ...otherPros} = props

    let options: Options | undefined = undefined

    if (children?.references) {
        options = {
            renderNode: {
                [BLOCKS.EMBEDDED_ENTRY]: node => {
                    const id = (node.data as ReferenceData).target.sys.id
                    const reference = children.references?.find(r => (r as Reference).contentful_id === id) as
                        | Reference
                        | undefined

                    let src = (reference && reference.url) ?? ""

                    if (reference && src.indexOf(YOUTUBE_VIDEO_1) > -1) {
                        src = `https://www.youtube.com/embed/${src.replace(YOUTUBE_VIDEO_1, "")}`
                    }
                    if (reference && src.indexOf(YOUTUBE_VIDEO_2) > -1) {
                        src = `https://www.youtube.com/embed/${src.replace(YOUTUBE_VIDEO_2, "")}`
                    }
                    if (reference && src.indexOf(VIMEO_VIDEO) > -1) {
                        src = `https://player.vimeo.com/video/${src.replace(VIMEO_VIDEO, "")}`
                    }

                    if (reference?.height != "") {
                        return (
                            `<div class="ref-container-z2vt" style="height:` +
                            reference?.height +
                            `">
                        <iframe class="ref-z2vt"
                            src=${src}
                            frameBorder="0"
                            allowFullScreen
                        ></iframe>
                    </div>`
                        )
                    }

                    return `<div class="ref-container-z2vt" >
                        <iframe class="ref-z2vt"
                            src=${src}
                            frameBorder="0"
                            allowFullScreen
                        ></iframe>
                    </div>`
                },
                [BLOCKS.EMBEDDED_ASSET]: node => {
                    const id = (node.data as ReferenceData).target.sys.id
                    const reference = children.references?.find(r => (r as Reference).contentful_id === id) as
                        | Reference
                        | undefined

                    const src = (reference && reference.url) ?? ""

                    if (reference && src.indexOf(CONTENTFUL_VIDEO) > -1) {
                        return `<div class="ref-container-z2vt">
                        <video class="ref-z2vt"
                        controls
                            playsInline
                            src=${reference.url}
                        ></video>
                    </div>`
                    }
                    if (reference && src.indexOf(CONTENTFUL_IMAGE) > -1) {
                        return `
                        <img class="ref-img-z2vt"
                            src=${reference.url}
                        ></img>
                    `
                    }

                    return ``
                },
            },
        }
    }

    return (
        <div
            className={clsx("reader-z2vt", asSubBlock ? "sub-block" : "default", className)}
            {...(children && children.raw
                ? {
                      dangerouslySetInnerHTML: {
                          __html: documentToHtmlString(JSON.parse(children.raw), options),
                      },
                  }
                : {})}
            {...otherPros}
        />
    )
}

export default Reader
